export const formGroup = {
    claimNo: {value: null},
    claimDate: {value: "", mandatory: true},
    kodeCabang: {value: ""},
    engineNumber: {value: "", mandatory: true},
    frameNumber: {value: ""},
    spbmNo: {value: ""},
    slNo: {value: ""},
    claimStatus: {value: {}, mandatory: true},
    hotlineOrder: {value: false},
    noFjb: {value: ""},
    chronology: {value: "", mandatory: true},
    locator: {value: "", mandatory: true},
    series: {value: ""},
    type: {value: ""},
    variant: {value: ""},
    warna: {value: ""},
}

export const tableConfig = [
    {
        name: "claimNo",
        label: "No Claim C1",
        options: {
            sort: false,
        }
    }, {
        name: "claimDate",
        label: "Tgl. Claim",
        options: {
            sort: false,
        }
    }, {
        name: "kodeCabang",
        label: "Kode Cabang",
        options: {
            sort: false,
        }
    }, {
        name: "kodeLocator",
        label: "Lokasi",
        options: {
            sort: false,
        }
    }, {
        name: "variant",
        label: "Variant",
        options: {
            sort: false,
        }
    }, {
        name: "warna",
        label: "Warna",
        options: {
            sort: false,
        }
    }, {
        name: "engineNumber",
        label: "Nosin",
        options: {
            sort: false,
        }
    }, {
        name: "frameNumber",
        label: "Noka",
        options: {
            sort: false,
        }
    }, {
        name: "claimStatus",
        label: "Status",
        options: {
            sort: false,
        }
    },
]